export default __webpack_public_path__ + "static/heading-background-9a0db5410f343bcafd735ec765a88d88.jpg";